<template>
  <Dialog
    titleAlign="left"
    :title="
      props.type == 'edit'
        ? $$t('editor.edit')
        : props.type == 'download'
        ? $$t('create.download')
        : $$t('create.more')
    "
    :visible="renderData.visible"
    @close="onClose"
    customClass="audio-item-op-items-dialog"
    mobileRenderType="drawerDialog"
  >
    <div
      class="audio-item-op-items-dialog-content"
      :class="{
        [`audio-item-op-items-dialog-content--${props.listRenderType}`]: true,
        [`audio-item-op-items-dialog-content--${props.type}`]: true,
      }"
    >
      <div class="audio-item-op-items-dialog-song" v-if="props.item">
        <AudioItem :item="props.item" :pitem="props.pitem"> </AudioItem>
        <div class="audio-item-op-items-dialog-song-mask"></div>
      </div>

      <!-- <div
        class="audio-item-op-item-top-box flex"
        v-if="
          props.isSelf &&
          !(
            isDisableByAudit() ||
            (props.pitem.state == 2 && !props.item.stream_key)
          ) &&
          props.renderType != 'createdetail'
        "
      >
        <div
          class="audio-item-op-item-top-item like-box"
          v-if="
            (props.isSelf &&
              !(
                isDisableByAudit() ||
                (props.pitem.state == 2 && !props.item.stream_key)
              ) &&
              props.renderType != 'createdetail') ||
            (!(
              isDisableByAudit() ||
              (props.pitem.state == 2 && !props.item.stream_key)
            ) &&
              props.renderType != 'createdetail' &&
              props.pitem?.generation_method != 6)
          "
        >
          <Button
            @click="doLike"
            :renderStyle="{
              '--padding': '0 15px',
              '--width': '100%',
              '--height': '42px',
              '--borderRadius': '50px',
              '--background': 'rgba(148, 173, 255, 0.2)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover': 'rgba(148, 173, 255, 0.3)',
              '--fontColor': '#fff',
            }"
          >
            <i
              class="audio-item-op-item-top-item-ico"
              :class="{
                'audio-liked': props.item.is_liked == 1,
                'audio-unlike': props.item.is_liked != 1,
              }"
            ></i>
            <span>
              {{
                props.item.is_liked == 1
                  ? $$t("create.liked")
                  : $$t("create.like")
              }}
            </span>
          </Button>
        </div>
        <div
          class="audio-item-op-item-top-item share-box"
          v-if="
            props.isSelf &&
            !(
              isDisableByAudit() ||
              (props.pitem.state == 2 && !props.item.stream_key)
            ) &&
            props.renderType != 'createdetail' &&
            props.pitem?.generation_method != 6
          "
        >
          <Button
            @click="doShare"
            :renderStyle="{
              '--padding': '0 15px',
              '--width': '100%',
              '--height': '42px',
              '--borderRadius': '50px',
              '--background': 'rgba(148, 173, 255, 0.2)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover': 'rgba(148, 173, 255, 0.3)',
              '--fontColor': '#fff',
            }"
          >
            <i class="audio-item-op-item-top-item-ico share-ico"></i>
            <span>{{ $$t("create.share") }}</span>
          </Button>
        </div>
      </div> -->

      <div
        class="audio-item-op-item audio-item-op-item-like-status"
        v-if="
          props.type == 'more' &&
          props.isSelf &&
          !(isDisableByAudit() || (props.pitem.state == 2 && !props.item.stream_key)) &&
          (props.renderType != 'createdetail' || createRenderType == 'mobile') &&
          props.pitem?.generation_method != 6
        "
        @click="doLike"
      >
        <i
          class="block"
          :class="{
            'like-true': props.item?.is_liked == 1 && props.item?.is_disliked != 1,
          }"
        ></i>
        <span class="block olh">
          {{
            props.item?.is_liked == 1 && props.item?.is_disliked != 1
              ? $$t("editor.unlike")
              : $$t("editor.like")
          }}
        </span>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-unlike-status"
        v-if="
          props.type == 'more' &&
          props.isSelf &&
          !(isDisableByAudit() || (props.pitem.state == 2 && !props.item.stream_key)) &&
          (props.renderType != 'createdetail' || createRenderType == 'mobile') &&
          props.pitem?.generation_method != 6
        "
        @click="doDislike"
      >
        <i
          class="block"
          :class="{
            'unlike-true': props.item?.is_disliked == 1 && props.item?.is_liked != 1,
          }"
        ></i>
        <span class="block olh">
          {{
            props.item?.is_disliked == 1 && props.item?.is_liked != 1
              ? $$t("editor.undislike")
              : $$t("editor.dislike")
          }}
        </span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-regenerate"
        v-if="
          props.type == 'edit' &&
          props.isSelf &&
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem?.state == 2 ||
            props.pitem?.generation_method == 7
          ) &&
          (!ModuleOpenStateControl.editor.regionEditing ||
            (ModuleOpenStateControl.editor.regionEditing && props.duration > 30))
        "
        @click="doRegenerate"
      >
        <i class="block"></i>
        <span class="block olh">{{
          ModuleOpenStateControl.editor.regionEditing
            ? $$t("editor.region_editing")
            : $$t("create.regenerate")
        }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        >
          <em>{{ $$t("create.pro_plan") }}</em>
        </label>
        <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.regionEditingBeta">
          {{ $$t("create.beta") }}
        </label>
        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'region_editing')
            }
          "
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-extend"
        v-if="
          props.type == 'edit' &&
          props.isSelf &&
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2 ||
            props.pitem?.generation_method == 7
          ) &&
          (ModuleOpenStateControl.editor.extendEditing ||
            (!ModuleOpenStateControl.editor.extendEditing && props.duration > 15))
        "
        @click="doExtend"
      >
        <i class="block"></i>
        <span class="block olh">{{
          ModuleOpenStateControl.editor.extendEditing
            ? $$t("editor.extend_editing")
            : $$t("create.extend")
        }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        >
          <em>{{ $$t("create.pro_plan") }}</em>
        </label>
        <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.extendEditingBeta">
          {{ $$t("create.beta") }}
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'extend')
            }
          "
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-trim"
        v-if="
          props.type == 'edit' &&
          props.isSelf &&
          !(props.isGenerating || isDisableByAudit() || props.pitem?.state == 2) &&
          ModuleOpenStateControl.editor.trimEditing &&
          props.duration > 30
        "
        @click="doTrimEditing"
      >
        <i class="block"></i>
        <span class="block olh">
          {{ $$t("editor.trim") }}
        </span>
        <!-- <label class="vip_plan_basic" v-if="!userDataStore.userInfo?.user?.is_vip">
          <em>{{ $$t("create.basic_plan") }}</em>
        </label> -->
        <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.trimEditingBeta">
          {{ $$t("create.beta") }}
        </label>

        <!-- <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'trim_editing');
            }
          "
          v-if="!userDataStore.userInfo?.user?.is_vip"
        ></div> -->
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-lyrics-translate"
        v-if="
          props.type == 'edit' &&
          props.isSelf &&
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2 ||
            props.pitem?.generation_method == 7
          ) &&
          ModuleOpenStateControl.editor.lyricsTranslate
        "
        @click="doLyricsTranslate"
      >
        <i class="block"></i>
        <span class="block olh"> {{ $$t("editor.lyrics_translate") }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        >
          <em>{{ $$t("create.pro_plan") }}</em>
        </label>
        <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.lyricsTranslateBeta">
          {{ $$t("create.beta") }}
        </label>
        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'lyrics_translate')
            }
          "
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-cover-voice"
        v-if="
          props.type == 'edit' &&
          props.isSelf &&
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2 ||
            props.pitem?.generation_method == 7
          ) &&
          ModuleOpenStateControl.editor.coverVoice
        "
        @click="doCoverVoice"
      >
        <i class="block"></i>
        <span class="block olh"> {{ $$t("editor.cover_voice") }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        >
          <em>{{ $$t("create.pro_plan") }}</em>
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'cover_voice')
            }
          "
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        ></div>
        <label class="beta_plan tc" v-if="ModuleOpenStateControl.editor.coverVoiceBeta">
          {{ $$t("create.beta") }}
        </label>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-generate-step-progress"
        v-if="
          props.isSelf &&
          !(props.isGenerating || props.pitem.state == 2) &&
          ModuleOpenStateControl.create.generateStepProgressMenu &&
          props.pitem?.thinking_process_url
        "
        @click="doShowGenerateStepProgress"
      >
        <i class="block"></i>
        <span class="block olh">
          {{ $$t("editor.generate_step_progress") }}
        </span>
      </div>

      <!-- <div
        class="audio-item-op-item"
        v-if="
          !(
            isDisableByAudit() ||
            (props.pitem.state == 2 && !props.item.stream_key)
          ) && props.renderType != 'createdetail'
        "
        :class="{
          'audio-item-op-item-like': props.item.is_liked == 1,
          'audio-item-op-item-unlike': props.item.is_liked != 1,
        }"
        @click="doLike"
      >
        <i class="block"></i>
        <span class="block olh">{{
          props.item.is_liked == 1 ? $$t("create.liked") : $$t("create.like")
        }}</span>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-share"
        v-if="
          !(
            isDisableByAudit() ||
            (props.pitem.state == 2 && !props.item.stream_key)
          ) &&
          props.renderType != 'createdetail' &&
          props.pitem?.generation_method != 6
        "
        @click="doShare"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.share") }}</span>
      </div> -->
      <!-- <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="
          props.isSelf &&
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2
          ) &&
          !props.pitem?.is_generated_from_uploaded_file
        "
        @click="doAddShoping"
      >
        <i class="block"></i>
        <span class="block olh">{{
          [1, 3, 4].includes(props.item?.publish_state)
            ? createRenderType == "mobile"
              ? $$t("create.unpublish")
              : $$t("create.published")
            : $$t("create.song_apply_to_publish")
        }}</span>
      </div> -->

      <div
        class="audio-item-op-item audio-item-op-item-release"
        v-if="
          props.type == 'more' &&
          props.isSelf &&
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2) &&
          ModuleOpenStateControl.create.release
        "
        @click="doRelease"
      >
        <i class="block"></i>
        <span class="block olh">{{
          props.item?.release_info?.release_state == 4
            ? $$t("create.released")
            : !props.item?.release_info?.release_state
            ? $$t("create.release")
            : $$t("create.releasing")
        }}</span>
      </div>

      <!-- <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 1"
        :class="{
          disabled: true,
        }"
      >
        <i class="block"></i>
        <span class="block olh">{{
          $$t("create.song_sale_under_review")
        }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 2"
        :class="{
          disabled: true,
        }"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.song_on_sale") }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 3"
        :class="{
          disabled: true,
        }"
      >
        <i class="block audio-item-op-item-sell"></i>
        <span class="block olh">{{ $$t("create.song_suspend_sale") }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 4"
        :class="{
          disabled: true,
        }"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.song_sold_out") }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 5"
        :class="{
          disabledui: true,
        }"
      >
        <i class="block"></i>
        <span class="block olh">{{
          $$t("create.song_sale_review_failed")
        }}</span>
        <i class="block tc info-ico" @click="openSaleReviewFailedReason">
        </i>
      </div> -->

      <div
        class="audio-item-op-item audio-item-op-item-download-video"
        v-if="
          props.type == 'download' &&
          props.isSelf &&
          !(
            [2, 3, 5, 6, 8].includes(props.pitem?.generation_method) ||
            props.pitem?.is_generated_from_uploaded_file
          ) &&
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
        "
        @click="doDownloadVideo"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.download_video") }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        >
          <em>{{ $$t("create.pro_plan") }}</em>
        </label>
        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_video')
            }
          "
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-download-ws"
        v-if="
          props.type == 'download' &&
          props.isSelf &&
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
        "
        @click="doDownloadWAVAndStem"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.download_wav_mp3") }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        >
          <em>{{ $$t("create.pro_plan") }}</em>
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_instrumental_stem')
            }
          "
          v-if="!['pro'].includes(userDataStore.userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-download-oc"
        v-if="
          props.type == 'download' &&
          props.isSelf &&
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2) &&
          !props.pitem?.is_generated_from_uploaded_file
        "
        @click="doDownloadCopyright"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.download_copyright") }}</span>
        <label class="vip_plan_basic" v-if="!userDataStore.userInfo?.user?.is_vip">
          <em>{{ $$t("create.basic_plan") }}</em>
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_license')
            }
          "
          v-if="!userDataStore.userInfo?.user?.is_vip"
        ></div>
      </div>
      <div
        v-if="
          props.type == 'download' &&
          props.isSelf &&
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
        "
        class="audio-item-op-item audio-item-op-item-download-mp3"
        @click="doDownloadMp3"
      >
        <i class="block"></i>
        <span class="block olh">{{
          props.pitem?.generation_method == 2
            ? $$t("editor.download_whole_mp3")
            : $$t("create.download_mp3")
        }}</span>
        <label class="vip_plan_basic" v-if="!userDataStore.userInfo?.user?.is_vip">
          <em>{{ $$t("create.basic_plan") }}</em>
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_mp3')
            }
          "
          v-if="!userDataStore.userInfo?.user?.is_vip"
        ></div>
      </div>
      <div
        v-if="
          props.type == 'download' &&
          props.isSelf &&
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2) &&
          ModuleOpenStateControl.editor.extendEditing &&
          props.pitem?.generation_method == 2
        "
        class="audio-item-op-item audio-item-op-item-download-extend-mp3"
        @click="doDownloadExtendMp3"
      >
        <i class="block"></i>
        <span class="block olh"> {{ $$t("editor.download_extend_mp3") }}</span>
        <label class="vip_plan_basic" v-if="!userDataStore.userInfo?.user?.is_vip">
          <em>{{ $$t("create.basic_plan") }}</em>
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_extend_mp3')
            }
          "
          v-if="!userDataStore.userInfo?.user?.is_vip"
        ></div>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-restore"
        v-if="
          props.type == 'more' &&
          props.isSelf &&
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
        "
        @click="doRestore"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.restore") }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-edit-song-title"
        v-if="
          props.type == 'more' &&
          props.isSelf &&
          !(
            props.isGenerating ||
            [1, 3, 4].includes(props.item.publish_state) ||
            isDisableByAudit() ||
            props.pitem.state == 2
          )
        "
        @click="
          () => {
            doEditSongTitle()
          }
        "
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.edit_feed_song_info") }}</span>
      </div>
      <div
        v-if="
          props.type == 'more' &&
          props.isSelf &&
          !(props.isGenerating || props.pitem?.state == 2) &&
          (props.renderType == 'createdetail' || createRenderType == 'mobile') &&
          ModuleOpenStateControl.speControl.feedback
        "
        class="audio-item-op-item audio-item-op-item-feedback"
        @click="doFreeback"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("editor.feedback") }}</span>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-delete"
        v-if="
          props.type == 'more' &&
          props.isSelf &&
          !(props.isGenerating || props.pitem.state == 2) &&
          isAllowedDelete()
        "
        @click="doDelete"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("create.delete") }}</span>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-report"
        v-if="
          props.type == 'more' &&
          globalConfig.appname == chinaAppName &&
          props.renderType == 'createdetail' &&
          !props.isSelf
        "
        @click="doReport"
      >
        <i class="block"></i>
        <span class="block olh">{{ $$t("editor.report") }}</span>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"
import { useRouter, useRoute } from "vue-router"

import Button from "@/components/basic/button/Button.vue"
import AudioItem from "@/page/create/feedList/audioItem.vue"

import globalConfig, { chinaAppName, ModuleOpenStateControl } from "@/config/config.js"

import { storeToRefs } from "pinia"
import useUserDataStore from "@/store/userDataStore"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const userDataStore = useUserDataStore()

const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.()).appContext?.config
  ?.globalProperties?.$router
const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  type: {
    type: String,
    default: "", // edit  download more
  },
  visible: {
    type: Boolean,
    default: false,
  },
  renderType: {
    type: String,
    default: "create", // createdetail // store
  },
  duration: {
    type: Number,
    default: 0,
  },
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
  listRenderType: {
    type: String,
    default: "create",
  },
  isGenerating: {
    type: Boolean,
    default: false,
  },
  isSelf: {
    type: Boolean,
    default: true,
  },
})
const emits = defineEmits([
  "update:visible",
  "from",
  "restore",
  "regenerate",
  "extend",
  "trimEditing",
  "lyricsTranslate",
  "coverVoice",
  "like",
  "dislike",
  "share",
  "more",
  "delete",
  "download",
  "addShoping",
  "release",
  "soldOut",
  "editSongTitle",
  "doDownloadVideo",
  "downloadMp3",
  "downloadExtendMp3",
  "downloadCopyright",
  "downloadWAVAndStem",
  "openSaleReviewFailedReason",
  "report",
  "feedback",
  "showGenerateStepProgress",
])
const renderData = reactive({
  visible: props.visible,
})

const doReport = () => {
  emits("report", props.pitem, props.item)
  renderData.visible = false
}

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation()
  if (await userDataStore.checkLoginStatus()) {
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    })
  }
}

const isDisableByAudit = () => {
  //2-ing 3- chenggong 4-failed
  // int64 machine_audit_state = 11;
  return (
    [4].includes(props.item?.machine_audit_state) ||
    [4].includes(props.item?.publish_state) ||
    props.pitem.state == 12 ||
    (globalConfig.appname == chinaAppName && props.pitem?.state == 2)
  )
}

const isAllowedDelete = () => {
  return true
}

const onClose = () => {
  renderData.visible = false
}

const doRestore = () => {
  emits("restore", props.pitem, props.item)
  renderData.visible = false
}

const doRegenerate = () => {
  emits("regenerate", props.pitem, props.item)
  renderData.visible = false
}

const doExtend = () => {
  emits("extend", props.pitem, props.item)
  renderData.visible = false
}

const doTrimEditing = () => {
  emits("trimEditing", props.pitem, props.item)
  renderData.visible = false
}

const doLyricsTranslate = () => {
  emits("lyricsTranslate", props.pitem, props.item)
  renderData.visible = false
}

const doCoverVoice = () => {
  emits("coverVoice", props.pitem, props.item)
  renderData.visible = false
}
const doShowGenerateStepProgress = () => {
  emits("showGenerateStepProgress", props.pitem, props.item)
  renderData.visible = false
}
const doFrom = () => {
  emits("from", props.pitem, props.item)
  renderData.visible = false
}

const doLike = () => {
  emits("like", props.pitem, props.item)
}

const doDislike = () => {
  emits("dislike", props.pitem, props.item)
}

const doDownload = () => {
  emits("download", props.pitem, props.item)
  renderData.visible = false
}

const doDownloadVideo = () => {
  emits("doDownloadVideo", props.pitem, props.item)
  renderData.visible = false
}

const doDownloadMp3 = () => {
  emits("downloadMp3", props.pitem, props.item)
  renderData.visible = false
}

const doDownloadExtendMp3 = () => {
  emits("downloadExtendMp3", props.pitem, props.item)
  renderData.visible = false
}

const doDownloadCopyright = () => {
  emits("downloadCopyright", props.pitem, props.item)
  renderData.visible = false
}

const doDownloadWAVAndStem = () => {
  emits("downloadWAVAndStem", props.pitem, props.item)
  renderData.visible = false
}

const doShare = () => {
  emits("share", props.pitem, props.item, (isSuccess) => {
    if (isSuccess) {
      // $$t("create.song_link_copied");
    }
  })
  renderData.visible = false
}

const doAddShoping = () => {
  emits("addShoping", props.pitem, props.item)
  renderData.visible = false
}

const doRelease = () => {
  emits("release", props.pitem, props.item)
  renderData.visible = false
}
const doSoldOut = () => {
  emits("soldOut", props.pitem, props.item)
  renderData.visible = false
}

const doFreeback = () => {
  emits("feedback", props.pitem, props.item)
  renderData.visible = false
}

const doDelete = () => {
  emits("delete", props.pitem, props.item)
  renderData.visible = false
}

const doEditSongTitle = () => {
  emits("editSongTitle", props.pitem, props.item)
  renderData.visible = false
}

const openSaleReviewFailedReason = () => {
  emits("openSaleReviewFailedReason", props.pitem, props.item)
}

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible
  }
)

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val)
  }
)

onMounted(() => {})
</script>
<style lang="scss">
.custom-dialog.audio-item-op-items-dialog {
  padding: 0 0 0 16px;
  .dialog-box {
    max-height: 80% !important;
  }
  .dialog-header {
    padding: 0 60px 0 20px;
  }
  .audio-item-op-items-dialog-content {
    padding: 0 0 32px 0;
  }
  .audio-item-op-items-dialog-content--likemysong {
    .audio-item-op-item-like {
      display: none;
    }
  }
  .audio-item-op-items-dialog-song {
    position: relative;
    margin: 8px 20px 8px 20px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    opacity: 0.5;
    .audio-item-play-status {
      display: none;
    }
    .audio-item-wave-box {
      display: none;
    }
    .audio-item-info-op-box {
      display: none;
    }
    .audio-item-cover-op {
      display: none !important;
    }
    .audio-item-cover-op-bg {
      * {
        display: none !important;
      }
    }
    .audio-item {
      padding: 12px 12px 12px 12px;
      pointer-events: none;
    }
    .audio-item-op-items-dialog-song-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .audio-item-op-item-top-box {
    padding: 12px 20px 12px 20px;
    .audio-item-op-item-top-item {
      width: 0;
      flex: 1;
      &.share-box {
        margin-left: 8px;
      }
    }
    .audio-item-op-item-top-item-ico {
      height: 20px;
      width: 20px;
      margin-right: 8px;
      &.audio-liked {
        background: url("@/assets/img/like-ico.png");
        background-size: 100% 100%;
      }
      &.audio-unlike {
        background: url("@/assets/img/audio-notlike-m-ico.png");
        background-size: 100% 100%;
      }
      &.share-ico {
        background: url("@/assets/img/audio-share-m-ico.png");
        background-size: 100% 100%;
      }
    }
  }
  .audio-item-op-item {
    height: 56px;
    padding: 0 20px;
    line-height: 44px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      width: 20px;
      height: 20px;
    }
    span {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;
      color: #ffffff;
      margin-left: 12px;
      flex: 1 1 0;
    }
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
    &.disabledui {
      opacity: 0.5;
      i,
      span {
        cursor: not-allowed;
      }
      i.info-ico {
        cursor: pointer;
      }
    }
    i.info-ico {
      width: 20px;
      height: 20px;
      background: url("@/assets/img/question-ico.png") !important;
      background-size: 100% 100% !important;
      border-radius: 20px;
      margin-left: 4px;
    }
    label.vip_plan {
      min-width: max-content;
      height: 20px;
      border-radius: 6px;
      padding: 0 6px;
      line-height: 20px;
      background: linear-gradient(135deg, #ffe08b 0%, #fff7d0 47.89%, #ffe08b 100%);
      margin: 0 0 0 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      em {
        font-style: italic;
        font-size: 12px;
        font-weight: 600;
        color: #402c00;
      }
    }
    label.vip_plan_basic {
      min-width: max-content;
      height: 20px;
      border-radius: 6px;
      padding: 0 6px;
      line-height: 20px;
      background: linear-gradient(100deg, #6cf 5.09%, #a9e2ff 49.09%, #6cf 93.1%);
      margin: 0 0 0 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      em {
        font-style: italic;
        font-size: 12px;
        font-weight: 600;
        color: #215385;
      }
    }

    .vip_plan-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .audio-item-op-item-like-status {
    i {
      background: url("@/assets/img/praise-ico-white.png");
      background-size: 100% 100%;
      opacity: 0.5;
    }
    i.like-true {
      background: url("@/assets/img/praise-high-ico-white.png");
      background-size: 100% 100%;
      opacity: 1;
    }
  }

  .audio-item-op-item-unlike-status {
    i {
      background: url("@/assets/img/praise-ico-white.png");
      background-size: 100% 100%;
      transform: rotate(180deg);
      opacity: 0.5;
    }
    i.unlike-true {
      background: url("@/assets/img/praise-high-ico-white.png");
      background-size: 100% 100%;
      opacity: 1;
    }
  }
  .audio-item-op-item-regenerate {
    i {
      background: url("@/assets/img/audio-regenerate-m-ico.png");
      background-size: 100% 100%;
      display: none;
    }
    span {
      margin-left: 0;
    }
  }
  .audio-item-op-item-extend {
    i {
      background: url("@/assets/img/audio-extend-m-ico.png");
      background-size: 100% 100%;
      display: none;
    }
    span {
      margin-left: 0;
    }
  }
  .audio-item-op-item-trim {
    i {
      background: url("@/assets/img/editor/icon-trim.png");
      background-size: 100% 100%;
      display: none;
    }
    span {
      margin-left: 0;
    }
  }
  .audio-item-op-item-lyrics-translate {
    i {
      background: url("@/assets/img/editor/icon-translate.png");
      background-size: 100% 100%;
      display: none;
    }
    span {
      margin-left: 0;
    }
  }

  .audio-item-op-item-cover-voice {
    i {
      background-image: url(@/assets/img/muse-leadvocal-ico.png);
      background-size: 100% 100%;
      display: none;
    }
    span {
      margin-left: 0;
    }
  }

  .audio-item-op-item-like {
    i {
      background: url("@/assets/img/like-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-unlike {
    i {
      background: url("@/assets/img/audio-notlike-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-share {
    i {
      background: url("@/assets/img/audio-share-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-sell {
    i {
      background: url("@/assets/img/more-publish.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-release {
    i {
      background: url("@/assets/img/more-release.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-download-video {
    i {
      background: url("@/assets/img/audio-video-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-download-mp3 {
    i {
      // background: url("@/assets/img/audio-download-mp3-ico.png");
      background: url("@/assets/img/download-audio-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-op-item-download-extend-mp3 {
    i {
      background: url("@/assets/img/download-extend-audio-ico.svg");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-download-oc {
    i {
      background: url("@/assets/img/audio-download-oc-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-download-ws {
    i {
      background: url("@/assets/img/audio-download-ws-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-restore {
    i {
      background: url("@/assets/img/audio-restore-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-edit-song-title {
    i {
      background: url("@/assets/img/audio-edit-m-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-op-item-feedback {
    i {
      background: url("@/assets/img/feedback-ico-white.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-op-item-generate-step-progress {
    i {
      background: url("@/assets/img/generate_step_progress.svg");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-delete {
    i {
      background: url("@/assets/img/audio-delete-m-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-op-item-report {
    i {
      background: url("@/assets/img/report-ico.svg");
      background-size: 100% 100%;
    }
  }
}
</style>
